import { ActiveSecurityContextStateService } from '@security/active-security/active-security-context.state-service';
import { OrganisationPermission } from '@security/permissions/permissions';
import { BulkImportHubGroup, BulkImportHubGroupView } from './bulk-import-hub.models';

export const BULK_IMPORT_HUB_GROUPS: readonly BulkImportHubGroup[] = [
  {
    id: 'pay-period',
    heading: 'Pay & period data',
    subheading: 'Load values into an open pay period for a specific payroll.',
    cards: [
      {
        id: 'one-off-payments',
        tid: 'import-type-one-off-payments-card',
        heading: 'One-off payment and deduction',
        description: 'Bonuses, expenses, advances or deductions for a single period. Pick your file format after choosing a payroll.',
        routeSegment: 'one-off-payments',
        importContextId: 'oneOffPayment',
        requiredPermission: 'EditOneOffPayments'
      }
    ]
  }
];

// Distinct permissions across every import type -- the "any of these" gate for the hub route guard.
export const BULK_IMPORT_PERMISSIONS: readonly OrganisationPermission[] = [
  ...new Set(BULK_IMPORT_HUB_GROUPS.flatMap((group) => group.cards.map((card) => card.requiredPermission)))
];

export function getVisibleHubGroups(activeSecurity: ActiveSecurityContextStateService): BulkImportHubGroupView[] {
  return BULK_IMPORT_HUB_GROUPS.map((group) => ({
    ...group,
    cards: group.cards.filter((card) => activeSecurity.hasOrganisationAuthorityTo(card.requiredPermission))
  })).filter((group) => group.cards.length > 0);
}

// Gate for the nav item and hub route guard, mirroring the payroll pattern: has an edit permission
// for at least one import type. Payroll vs group scope is resolved later, in the selection modal.
export function hasAnyBulkImportPermission(activeSecurity: ActiveSecurityContextStateService): boolean {
  return getVisibleHubGroups(activeSecurity).length > 0;
}
